import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import Header from '../../../../customs/Header';
import SettingsModal from '../Modal/settingsCustomModal';
import QualificationContent from './QualificationContent';
import CreateQualificationContent from './CreateQualification';
import apiCall from '../../../../utils/apiCall';

interface QualificationResponse {
  StatusCode: number;
  Message: string;
  Data: Qualification[];
}

interface Qualification {
  id: number;
  QualificationId: number;
  QualificationName: string;
  Score: number;
  CreatedBy: string;
  ModifiedBy: string;
  CreateDate: string;
  LastModified: string;
  ActiveStatus: boolean;
  IsApprovalRequired: boolean;
  LevelBy: number;
  ApprovalTypeId: number;
  IsDeleted: boolean;
}

export default function Qualification(){
  const [openCreateQualificationModal, setOpenCreateQualificationModal] = useState(false);

  const handleOpenCreateQualificationModal = () => setOpenCreateQualificationModal(true);
  const handleCloseCreateQualificationModal = () => setOpenCreateQualificationModal(false);
  
  const getAllQualification = async(): Promise<QualificationResponse> => {
    return (await apiCall().get('/SetUp/GetAllQualification')).data
  };

  const { data, isLoading, isError, error } = useQuery(['get-qualifications'], getAllQualification, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });

  const qualificationResponseError = error as AxiosError;
  const qualificationErrorMessage = qualificationResponseError?.message;

  return (
    <section>
      <Header props={
        { 
          firstName: 'All', 
          secondName: 'Qualification', 
          buttonText: 'Create Qualification'
        }}
        handleOpen={handleOpenCreateQualificationModal}
      />
      {isLoading ? (
        <CircularProgress 
          sx={{
            fontSize: '1rem',
            marginInline: 'auto',
            display: 'block',
            marginBlock: '2rem'
          }}
        />
      ) : isError ? (
        <StyledError>{qualificationErrorMessage}</StyledError>
      ) : (
        <QualificationContent qualification={data}/>
      )}

      <SettingsModal 
        open={openCreateQualificationModal}
        cancel={handleCloseCreateQualificationModal}
        maxWidth='480px'
        header='Create Qualification'
        showrightIcon={false}
        content={<CreateQualificationContent 
          handleClose={handleCloseCreateQualificationModal} 
          qualification={data?.Data[data?.Data?.length - 1]}
        />}      
      />
    </section>
  )
};

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`
